// client_Web/src/components/PrivacyPolicy.js

import React from 'react';
import { Helmet } from 'react-helmet';
import '../styles/App.css'; // Ensure consistent styling

function PrivacyPolicy() {
  return (
    <main className="privacy-policy-page page-wrap">
      <Helmet>
        <title>Privacy Policy | WizeAssist</title>
        <meta
          name="description"
          content="Read the Privacy Policy of WizeAssist to understand how we handle your personal information."
        />
        {/* Open Graph Meta Tags */}
        <meta property="og:title" content="Privacy Policy | WizeAssist" />
        <meta
          property="og:description"
          content="Read the Privacy Policy of WizeAssist to understand how we handle your personal information."
        />
        <meta property="og:type" content="website" />
        <meta property="og:url" content="https://www.wizeassist.com/privacy-policy" />
        <meta
          property="og:image"
          content="https://www.wizeassist.com/assets/images/og-image-privacy.jpg"
        /> {/* Replace with actual image */}

        {/* Twitter Card Meta Tags */}
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:title" content="Privacy Policy | WizeAssist" />
        <meta
          name="twitter:description"
          content="Read the Privacy Policy of WizeAssist to understand how we handle your personal information."
        />
        <meta
          name="twitter:image"
          content="https://www.wizeassist.com/assets/images/twitter-image-privacy.jpg"
        />

        {/* Structured Data for Privacy Policy Page */}
        <script type="application/ld+json">
          {JSON.stringify({
            "@context": "https://schema.org",
            "@type": "WebPage",
            "name": "Privacy Policy",
            "description":
              "Read the Privacy Policy of WizeAssist to understand how we handle your personal information.",
            "url": "https://www.wizeassist.com/privacy-policy",
          })}
        </script>
      </Helmet>

      <h1 className="text-teal mb-4">Privacy Policy</h1>
      <div className="container">
        <section className="privacy-section">
          <h2>1. Introduction</h2>
          <p>
            Welcome to WizeAssist. We are committed to protecting your personal information
            and your right to privacy. If you have any questions or concerns about our policy
            or our practices regarding your personal information, please contact us at 
            support@wizeassist.com.
          </p>
        </section>

        <section className="privacy-section">
          <h2>2. Information We Collect</h2>
          <p>
            We collect personal information that you voluntarily provide to us when registering
            on the Services, expressing an interest in obtaining information about us or our
            products and services, when participating in activities on the Services or otherwise
            contacting us.
          </p>
        </section>

        <section className="privacy-section">
          <h2>3. How We Use Your Information</h2>
          <p>
            We use the information we collect or receive to facilitate account creation and
            logon process, deliver services, manage user accounts, communicate with you, and 
            improve our services.
          </p>
        </section>

        <section className="privacy-section">
          <h2>4. Sharing Your Information</h2>
          <p>
            We do not share your personal information with third parties except as necessary to
            provide our services or as required by law.
          </p>
        </section>

        <section className="privacy-section">
          <h2>5. Security of Your Information</h2>
          <p>
            We use administrative, technical, and physical security measures to help protect your
            personal information. While we have taken reasonable steps to secure the personal
            information you provide to us, please be aware that despite our efforts, no security
            measures are perfect or impenetrable.
          </p>
        </section>

        <section className="privacy-section">
          <h2>6. Your Privacy Rights</h2>
          <p>
            Depending on your location, you may have the right to access, correct, or delete
            the personal information we collect about you. To exercise these rights, please
            contact us at support@wizeassist.com.
          </p>
        </section>

        <section className="privacy-section">
          <h2>7. Changes to This Privacy Policy</h2>
          <p>
            We may update our Privacy Policy from time to time. We will notify you of any changes
            by posting the new Privacy Policy on this page.
          </p>
        </section>

        <section className="privacy-section">
          <h2>8. Contact Us</h2>
          <p>
            If you have any questions about this Privacy Policy, please contact us:
          </p>
          <ul>
            <li>Email: <a href="mailto:support@wizeassist.com">support@wizeassist.com</a></li>
          </ul>
        </section>
      </div>
    </main>
  );
}    
export default PrivacyPolicy;
